import { combineReducers } from '@reduxjs/toolkit';
import {AppReducer} from "./app";
import {VehicleReducer} from "./vehicles"
import {AuthReducer} from "./auth"
import {BackdropReducer} from "./backdrop"
import {NotifierReducer} from "./notifier"
import {ReportReducer} from "./report"
import {GuideReducer} from "./guides"
export const rootReducer = combineReducers({
    app:AppReducer,
    vehicle:VehicleReducer,
    auth:AuthReducer,
    backdrop:BackdropReducer,
    guide:GuideReducer,
    report:ReportReducer,
    notifier:NotifierReducer
})

export type RootState = ReturnType<any>

export default rootReducer

